/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';

import { FileDnsServiceModuleEmbed } from '../../../../../../../settings/file-storage-service/file-dns-service/file-dns-service.module';
import { ConfigureDnsComponent } from './configure-dns.component';

@NgModule({
    declarations: [ConfigureDnsComponent],
    exports: [ConfigureDnsComponent],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
        FileDnsServiceModuleEmbed,
    ],
})
export class ConfigureDnsModule { }
